import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';

@Injectable()
export class LinkValidationResolve implements Resolve<any> {

    constructor(private http: HttpClient,
                private router: Router) {

    }

    resolve(route: ActivatedRouteSnapshot) {
        return new Observable(observer => {
            let link = route.params['link'];
            this.http.get(`/api/validate/${link}`).subscribe((result : any) => {
                if (!result.valid) {
                    this.router.navigate([`/${link}/utilized/${result.language}`]);
                    observer.next(false);
                } else {
                    observer.next(true);
                }
                observer.complete();
            });
        });
    }
}